import { render, staticRenderFns } from "./carRecord.vue?vue&type=template&id=0d8e7e1e&scoped=true&"
import script from "./carRecord.vue?vue&type=script&lang=js&"
export * from "./carRecord.vue?vue&type=script&lang=js&"
import style0 from "./carRecord.vue?vue&type=style&index=0&id=0d8e7e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e7e1e",
  null
  
)

export default component.exports